import script from "./TestPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TestPage.vue?vue&type=script&setup=true&lang=js"

import "./TestPage.vue?vue&type=style&index=0&id=9dbe7528&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dbe7528"]])

export default __exports__